import React, { useState } from 'react';
import {
  Button,
  Container,
  TextField,
  Table,
  Modal,
  TableBody,
  TableCell,
  Box,
  styled,
  Typography,
  TableContainer,
  IconButton,
  TableHead,
  TableRow,
  Paper,
  InputAdornment,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Tooltip,
  useTheme,
} from '@mui/material';
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';
import {
  Delete as DeleteIcon,
  Edit as EditIcon,
  Add as AddIcon,
  Close as CloseIcon,
  KeyboardDoubleArrowLeft as ChevronLeft,
  KeyboardDoubleArrowRight as ChevronRight,
} from '@mui/icons-material';
import SearchIcon from '@mui/icons-material/Search';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
const CustomTableScrollbar = styled('div')(({ theme }) => ({
  '&::-webkit-scrollbar': {
    height: '6px',
    background: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.2)',
    borderRadius: '3px',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.3)',
  },
  scrollbarWidth: 'thin',
  scrollbarColor: `${theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.2)'} transparent`,
}));
const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const OtherIncomeItem = () => {
  const theme = useTheme();
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [showUserGuideModal, setShowUserGuideModal] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  

const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [searchTerm, setSearchTerm] = useState('');
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showAddIncomeItemModal, setShowAddIncomeItemModal] = useState(false);
  const [showEditIncomeItemModal, setShowEditIncomeItemModal] = useState(false);
  const [selectedIncomeItem, setSelectedIncomeItem] = useState({ incomeItemId: null, itemName: '' });
  const [formData, setFormData] = useState({
    groupName: '',
    itemName: '',
    remark: '',
  });

  // Static data for other income items
  const staticOtherIncomeItemData = [
    { incomeItemId: 1, groupName: 'Investments', itemName: 'Stock Dividends', remark: 'Dividends from stock investments' },
    { incomeItemId: 2, groupName: 'Rental Income', itemName: 'Residential Rent', remark: 'Income from residential rentals' },
    { incomeItemId: 3, groupName: 'Freelance', itemName: 'Consulting Fees', remark: 'Fees from consulting services' },
    { incomeItemId: 4, groupName: 'Dividends', itemName: 'Bond Interest', remark: 'Interest from bond investments' },
    { incomeItemId: 5, groupName: 'Royalties', itemName: 'Book Royalties', remark: 'Royalties from book sales' },
    { incomeItemId: 6, groupName: 'Gifts', itemName: 'Cash Gifts', remark: 'Cash gifts received' },
  ];

  // Static data for other income groups
  const incomeGroups = [
    { id: 1, name: 'Investments' },
    { id: 2, name: 'Rental Income' },
    { id: 3, name: 'Freelance' },
    { id: 4, name: 'Dividends' },
    { id: 5, name: 'Royalties' },
    { id: 6, name: 'Gifts' },
  ];

  const handleAddIncomeItem = () => {
    setFormData({
      groupName: '',
      itemName: '',
      remark: '',
    });
    setShowAddIncomeItemModal(true);
  };

  const handleEdit = (incomeItem) => {
    setSelectedIncomeItem({ incomeItemId: incomeItem.incomeItemId, itemName: incomeItem.itemName });
    setFormData({
      groupName: incomeItem.groupName,
      itemName: incomeItem.itemName,
      remark: incomeItem.remark,
    });
    setShowEditIncomeItemModal(true);
  };

  const handleDelete = (incomeItemId, itemName) => {
    setSelectedIncomeItem({ incomeItemId, itemName });
    setShowDeleteModal(true);
  };

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
     setSnackbarMessage('Deleted successfully!');  
  setOpenSnackbar(true);  
  setSnackbarSeverity("success");
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSave = (e) => {
    e.preventDefault();
    if (!formData.groupName || !formData.itemName || !formData.remark) {
      setSnackbarMessage('plz fill rquired field!');  
  setOpenSnackbar(true);  
  setSnackbarSeverity("error");
      return;
    }
    setSnackbarMessage('Other Income Item Added Successfully');
    setOpenSnackbar(true);
    setSnackbarSeverity('success')
    setShowAddIncomeItemModal(false);
    setFormData({
      groupName: '',
      itemName: '',
      remark: '',
    });
  };

  const handleUpdate = () => {
    if (!formData.groupName || !formData.itemName || !formData.remark) {
      setSnackbarMessage('plz fill rquired field!');  
  setOpenSnackbar(true);  
  setSnackbarSeverity("error");
      return;
    }
    setSnackbarMessage('Other Income Item Updated Successfully');
    setOpenSnackbar(true);
    setSnackbarSeverity('success')
    setShowEditIncomeItemModal(false);
  };

  const handleReset = () => {
    setFormData({
      groupName: '',
      itemName: '',
      remark: '',
    });
  };

  const handleCancel = () => {
    setShowEditIncomeItemModal(false);
  };

  const filteredData = staticOtherIncomeItemData.filter((incomeItem) =>
    incomeItem.groupName.toLowerCase().includes(searchTerm.toLowerCase()) ||
    incomeItem.itemName.toLowerCase().includes(searchTerm.toLowerCase()) ||
    incomeItem.remark.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const paginatedData = filteredData.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage
  );

  return (
    <Container>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1, p: 2, boxShadow: 'none', maxWidth: '100%', boxSizing: 'border-box' }}>
        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 2 }}>
        <TextField
                           variant="outlined"
                           placeholder="Search..."
                           value={searchTerm}
                           onChange={(e) => setSearchTerm(e.target.value)}
                           InputProps={{
                             startAdornment: (
                               <InputAdornment position="start">
                                 <SearchIcon
                                   sx={{
                                     color: theme.palette.primary.main,
                                     marginLeft: 1.5,
                                     fontSize: 24,
                                   }}
                                 />
                               </InputAdornment>
                             ),
                             endAdornment: searchTerm && (
                               <InputAdornment position="end">
                                 <IconButton
                                   size="small"
                                   onClick={() => setSearchTerm('')}
                                   sx={{
                                     color: "grey",
                                     marginRight: 1,
                                   }}
                                 >
                                   <CloseIcon fontSize="small" />
                                 </IconButton>
                               </InputAdornment>
                             ),
                             sx: {
                               borderRadius: '30px',
                               backgroundColor: theme.palette.mode === 'dark'
                                 ? 'rgba(255, 255, 255, 0.15)'
                                 : 'rgba(255, 255, 255, 1)',
                               boxShadow: theme.palette.mode === 'dark'
                                 ? '0 2px 8px rgba(0, 0, 0, 0.3)'
                                 : '0 2px 8px rgba(0, 0, 0, 0.1)',
                               '& .MuiOutlinedInput-notchedOutline': {
                                 border: `1px solid ${theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0, 0, 0, 0.1)'}`,
                               },
                               '&:hover': {
                                 backgroundColor: theme.palette.mode === 'dark'
                                   ? 'rgba(255, 255, 255, 0.2)'
                                   : 'rgba(240, 240, 240, 1)',
                                 boxShadow: theme.palette.mode === 'dark'
                                   ? '0 2px 12px rgba(0, 0, 0, 0.4)'
                                   : '0 2px 12px rgba(0, 0, 0, 0.15)',
                               },
                               '&.Mui-focused': {
                                 backgroundColor: theme.palette.mode === 'dark'
                                   ? 'rgba(255, 255, 255, 0.25)'
                                   : 'rgba(255, 255, 255, 1)',
                                 boxShadow: `0 0 0 3px ${theme.palette.primary.main}20`,
                                 '& .MuiOutlinedInput-notchedOutline': {
                                   border: `2px solid ${theme.palette.primary.main}`,
                                 },
                               },
                               paddingLeft: 1.5,
                               height: '50px',
                               transition: 'all 0.3s ease',
                             },
                           }}
                           sx={{
                             width: 350,
                             maxWidth: '100%',
                             '& .MuiInputBase-input': {
                               padding: '10px 14px',
                               color: theme.palette.text.primary,
                               fontWeight: 500,
                             },
                           }}
                         />
        <Button
          variant="contained"
          onClick={handleAddIncomeItem}
          sx={{
            ml: 2,
            width: "100px",
            height: "50px",
            borderRadius: "10px",
            padding: "10px 0",
            fontWeight: 'bold',
            backgroundColor: theme.palette.primary.main,
            '&:hover': { backgroundColor: theme.palette.primary.dark },
          }}
          startIcon={<AddIcon />}
        >
          ADD
        </Button>
        </Box>
        <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <IconButton
                    onClick={() => setShowUserGuideModal(true)}
                    sx={{
                      width: 60,
                      height: 60,
                      borderRadius: '50%',
                      minWidth: 0, // Remove MUI's default padding
                    }}
                  >
                    <InfoOutlineIcon sx={{ fontSize: 30 }} />
                  </IconButton>
                </Box>
      </Box>
<Paper elevation={3} sx={{ paddingBottom: 0, maxWidth: '100%', boxSizing: 'border-box', mx: 'auto', backgroundColor: theme.palette.background.paper, borderRadius: '16px' }}>
  <CustomTableScrollbar sx={{ width: '100%', overflowX: 'auto' }}>
    <TableContainer sx={{ width: '100%', borderRadius: '16px' }}>
      <Table
        sx={{
          '& .MuiTableHead-root .MuiTableCell-root': {
            fontWeight: 'bold',
            backgroundColor: theme.palette.primary.main,
            color: 'white',
          },
        }}
      >
        <TableHead>
          <TableRow>
            <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem' }}>S.No</TableCell>
            <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem' }}>Group Name</TableCell>
            <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem' }}>Item Name</TableCell>
            <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem' }}>Remark</TableCell>
            <TableCell align="center" sx={{ fontWeight: 'bold', backgroundColor: theme.palette.primary.dark, fontSize: '1.1rem' }}>Action</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {paginatedData.length > 0 ? (
            paginatedData.map((incomeItem, index) => (
              <TableRow
                key={incomeItem.incomeItemId}
                sx={{
                  backgroundColor: index % 2 === 0 ? theme.palette.background.paper : theme.palette.background.paper,
                  '&:hover': {
                    backgroundColor: 'rgba(0, 0, 0, 0.04)',
                  },
                }}
              >
                <TableCell sx={{ fontSize: '1rem' }}>{(page - 1) * rowsPerPage + index + 1}</TableCell>
                <TableCell sx={{ fontSize: '1rem' }}>{incomeItem.groupName}</TableCell>
                <TableCell sx={{ fontSize: '1rem' }}>{incomeItem.itemName}</TableCell>
                <TableCell sx={{ fontSize: '1rem' }}>{incomeItem.remark}</TableCell>
                <TableCell align="center">
                  <IconButton
                    onClick={() => handleEdit(incomeItem)}
                    sx={{
                      color: theme.palette.primary.light,
                      '&:hover': {
                        backgroundColor: 'rgba(0, 0, 0, 0.04)',
                      },
                    }}
                  >
                    <EditIcon />
                  </IconButton>
                  <IconButton
                    color="error"
                    onClick={() => handleDelete(incomeItem.incomeItemId, incomeItem.itemName)}
                    sx={{
                      '&:hover': {
                        backgroundColor: 'rgba(0, 0, 0, 0.04)',
                      },
                    }}
                  >
                    <DeleteIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow
              sx={{
                backgroundColor: theme.palette.background.paper,
                '&:hover': {
                  backgroundColor: 'rgba(0, 0, 0, 0.04)',
                },
              }}
            >
              <TableCell colSpan={5} align="center" sx={{ fontSize: '1rem', padding: '20px', wordSpacing: 7 }}>
                No Data Found
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  </CustomTableScrollbar>
</Paper>
      {filteredData.length > 0 && (
        <Box
          sx={{
            maxWidth: '100%',
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mt: 1,
            p: 2,
            mx: 'auto',
            pt: 2,
          }}
        >
          <Typography
            variant="body2"
            color={theme.palette.primary.main}
          >
            Page <strong>{page}</strong> of <strong>{Math.ceil(filteredData.length / rowsPerPage)}</strong>
          </Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <IconButton
              onClick={() => handleChangePage(null, page - 1)}
              disabled={page === 1}
              sx={{
                color: theme.palette.primary.main,
                '&:hover': {
                  backgroundColor: theme.palette.action.hover,
                },
                '&.Mui-disabled': {
                  opacity: 0.3,
                },
                borderRadius: '50%',
                width: '36px',
                height: '36px',
              }}
            >
              <ChevronLeft />
            </IconButton>
            {[...Array(Math.ceil(filteredData.length / rowsPerPage))].map((_, index) => (
              <IconButton
                key={index + 1}
                onClick={() => handleChangePage(null, index + 1)}
                sx={{
                  width: '36px',
                  height: '36px',
                  borderRadius: '50%',
                  backgroundColor: page === index + 1 ? theme.palette.primary.main : 'transparent',
                  color: page === index + 1 ? theme.palette.primary.contrastText : theme.palette.text.primary,
                  '&:hover': {
                    backgroundColor: page === index + 1 ? theme.palette.primary.dark : theme.palette.action.hover,
                  },
                }}
              >
                {index + 1}
              </IconButton>
            ))}
            <IconButton
              onClick={() => handleChangePage(null, page + 1)}
              disabled={page >= Math.ceil(filteredData.length / rowsPerPage)}
              sx={{
                color: theme.palette.primary.main,
                '&:hover': {
                  backgroundColor: theme.palette.action.hover,
                },
                '&.Mui-disabled': {
                  opacity: 0.3,
                },
                borderRadius: '50%',
                width: '36px',
                height: '36px',
              }}
            >
              <ChevronRight />
            </IconButton>
            <FormControl size="small" sx={{ minWidth: 100, ml: 1 }}>
              <InputLabel id="rows-per-page-label" sx={{ color: theme.palette.text.primary }}>Rows</InputLabel>
              <Select
                labelId="rows-per-page-label"
                value={rowsPerPage}
                onChange={handleChangeRowsPerPage}
                label="Rows"
                sx={{
                  height: '36px',
                  color: theme.palette.text.primary,
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.text.primary,
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.primary.main,
                  },
                }}
              >
                <MenuItem value={5}>5</MenuItem>
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={20}>20</MenuItem>
                <MenuItem value={30}>30</MenuItem>
              </Select>
            </FormControl>
          </Box>
        </Box>
      )}
      <Snackbar
        open={openSnackbar}
        autoHideDuration={4000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={() => setOpenSnackbar(false)} severity="success" sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
      <Modal open={showDeleteModal} onClose={handleCloseDeleteModal} BackdropProps={{ style: { backgroundColor: 'rgba(0, 0, 0, 0.8)' } }}>
        <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 400, bgcolor: 'background.paper', borderRadius: 2, boxShadow: 24, overflow: 'hidden' }}>
          <Box sx={{ backgroundColor: theme.palette.primary.main, padding: '12px 16px' }}>
            <Typography id="delete-modal-title" variant="h6" sx={{ color: '#fff' }}>
              Delete Confirmation ⚠️
            </Typography>
          </Box>
          <Box sx={{ padding: '20px' }}>
            <Typography id="delete-modal-description" sx={{ mb: 2 }}>
              Are you sure you want to delete {selectedIncomeItem.itemName}?
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button onClick={handleCloseDeleteModal} variant="outlined" sx={{ mr: 1 }} data-app-cancel="true">
                Cancel
              </Button>
              <Button variant="contained" color="error" onClick={handleCloseDeleteModal}>
                Yes, Delete
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
      <Modal open={showAddIncomeItemModal} onClose={() => setShowAddIncomeItemModal(false)} BackdropProps={{ style: { backgroundColor: 'rgba(0, 0, 0, 0.8)' } }}>
        <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 600, bgcolor: 'background.paper', borderRadius: 2, boxShadow: 24, overflow: 'hidden' }}>
          <Box sx={{ backgroundColor: theme.palette.primary.main, padding: '12px 16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="h6" sx={{ color: '#fff', fontWeight: 'bold' }}>
              Add Other Income Item
            </Typography>
            <IconButton onClick={() => setShowAddIncomeItemModal(false)} sx={{ color: '#fff' }}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Box sx={{ padding: '20px' }}>
            <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
              <FormControl fullWidth>
                <InputLabel id="income-group-label" sx={{ color: theme.palette.text.primary, '&.Mui-focused': { color: theme.palette.primary.main } }}>
                  Other Income Group
                </InputLabel>
                <Select
                  labelId="income-group-label"
                  id="groupName"
                  name="groupName"
                  value={formData.groupName}
                  label="Other Income Group"
                  onChange={handleChange}
                  sx={{
                    '& .MuiInputLabel-root': { color: theme.palette.text.primary },
                    '& .MuiInputLabel-root.Mui-focused': { color: theme.palette.primary.main },
                  }}
                >
                  {incomeGroups.map((group) => (
                    <MenuItem key={group.id} value={group.name}>
                      {group.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
            <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
              <TextField
                label="Other Income Item"
                variant="outlined"
                fullWidth
                name="itemName"
                value={formData.itemName}
                onChange={handleChange}
                sx={{
                  '& .MuiInputLabel-root': { color: theme.palette.text.primary },
                  '& .MuiInputLabel-root.Mui-focused': { color: theme.palette.primary.main },
                }}
              />
            </Box>
            <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
              <TextField
                label="Remark"
                variant="outlined"
                fullWidth
                name="remark"
                value={formData.remark}
                onChange={handleChange}
                sx={{
                  '& .MuiInputLabel-root': { color: theme.palette.text.primary },
                  '& .MuiInputLabel-root.Mui-focused': { color: theme.palette.primary.main },
                }}
              />
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Tooltip
                title={
                  !formData.groupName ? 'Select Other Income Group' :
                  !formData.itemName ? 'Enter Other Income Item' :
                  !formData.remark ? 'Enter Remark' : ''
                }
                arrow
              >
                <Button
                  variant="contained"
                  onClick={handleSave}
                  sx={{
                    mr: 2,
                    backgroundColor: theme.palette.primary.main,
                    '&:hover': { backgroundColor: theme.palette.primary.dark },
                  }}
                  disabled={!formData.groupName || !formData.itemName || !formData.remark}
                >
                  SAVE
                </Button>
              </Tooltip>
              <Button
                variant="contained"
                color="error"
                onClick={handleReset}
              >
                RESET
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
      <Modal open={showEditIncomeItemModal} onClose={handleCancel} BackdropProps={{ style: { backgroundColor: 'rgba(0, 0, 0, 0.8)' } }}>
        <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 600, bgcolor: 'background.paper', borderRadius: 2, boxShadow: 24, overflow: 'hidden' }}>
          <Box sx={{ backgroundColor: theme.palette.primary.main, padding: '12px 16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="h6" sx={{ color: '#fff', fontWeight: 'bold' }}>
              Edit Other Income Item
            </Typography>
            <IconButton onClick={handleCancel} sx={{ color: '#fff' }}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Box sx={{ padding: '20px' }}>
            <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
              <FormControl fullWidth>
                <InputLabel id="income-group-label" sx={{ color: theme.palette.text.primary, '&.Mui-focused': { color: theme.palette.primary.main } }}>
                  Other Income Group
                </InputLabel>
                <Select
                  labelId="income-group-label"
                  id="groupName"
                  name="groupName"
                  value={formData.groupName}
                  label="Other Income Group"
                  onChange={handleChange}
                  sx={{
                    '& .MuiInputLabel-root': { color: theme.palette.text.primary },
                    '& .MuiInputLabel-root.Mui-focused': { color: theme.palette.primary.main },
                  }}
                >
                  {incomeGroups.map((group) => (
                    <MenuItem key={group.id} value={group.name}>
                      {group.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
            <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
              <TextField
                label="Other Income Item"
                variant="outlined"
                fullWidth
                name="itemName"
                value={formData.itemName}
                onChange={handleChange}
                sx={{
                  '& .MuiInputLabel-root': { color: theme.palette.text.primary },
                  '& .MuiInputLabel-root.Mui-focused': { color: theme.palette.primary.main },
                }}
              />
            </Box>
            <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
              <TextField
                label="Remark"
                variant="outlined"
                fullWidth
                name="remark"
                value={formData.remark}
                onChange={handleChange}
                sx={{
                  '& .MuiInputLabel-root': { color: theme.palette.text.primary },
                  '& .MuiInputLabel-root.Mui-focused': { color: theme.palette.primary.main },
                }}
              />
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Tooltip
                title={
                  !formData.groupName ? 'Select Other Income Group' :
                  !formData.itemName ? 'Enter Other Income Item' :
                  !formData.remark ? 'Enter Remark' : ''
                }
                arrow
              >
                <Button
                  variant="contained"
                  onClick={handleUpdate}
                  sx={{
                    mr: 2,
                    backgroundColor: theme.palette.primary.main,
                    '&:hover': { backgroundColor: theme.palette.primary.dark },
                  }}
                  disabled={!formData.groupName || !formData.itemName || !formData.remark}
                >
                  UPDATE
                </Button>
              </Tooltip>
              <Button
                variant="contained"
                color="error"
                onClick={handleCancel}
              >
                CANCEL
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
      <Modal
      open={showUserGuideModal}
      onClose={() => setShowUserGuideModal(false)}
      BackdropProps={{ style: { backgroundColor: 'rgba(0, 0, 0, 0.8)' } }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 800,
          bgcolor: 'background.paper',
          borderRadius: '16px',
          boxShadow: 24,
          overflow: 'hidden',
        }}
      >
        {/* Header */}
        <Box
          sx={{
            backgroundColor: theme.palette.primary.main,
            padding: '12px 16px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            position: 'relative',
          }}
        >
          <Typography variant="h4" sx={{ color: '#fff', fontWeight: 'bold' }}>
            Other Income Item Management - User Guide
          </Typography>
          <IconButton
            onClick={() => setShowUserGuideModal(false)}
            sx={{ color: '#fff', position: 'absolute', right: 14 }}
          >
            <CloseIcon />
          </IconButton>
        </Box>

        {/* Scrollable Content */}
        <CustomTableScrollbar sx={{ maxHeight: '70vh', overflowY: 'auto', padding: '20px' }}>
          {/* Section 1: Search Other Income Items */}
          <Typography
            variant="body1"
            sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mb: 1 }}
          >
            ➤ Follow these steps to search for other income items:
          </Typography>
          <ul
            style={{
              marginLeft: '20px',
              lineHeight: '1.8',
              cursor: 'default',
            }}
          >
            <li>
              In the search bar at the top left, enter a keyword related to the group name, item name, or remark of the other income item.
            </li>
            <li>
              The table will automatically filter to display only the items matching the search term.
            </li>
            <li>
              Clear the search bar to view all other income items again.
            </li>
          </ul>
          <Typography variant="body2" sx={{ mt: 2, color: theme.palette.text.primary }}>
            ⚠️ Note: The search is case-insensitive and matches partial text in the group name, item name, or remark fields.
          </Typography>

          {/* Section 2: Add an Other Income Item */}
          <Typography
            variant="body1"
            sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mt: 3, mb: 1 }}
          >
            ➤ Follow these steps to add an other income item:
          </Typography>
          <ul
            style={{
              marginLeft: '20px',
              lineHeight: '1.8',
              cursor: 'default',
            }}
          >
            <li>
              Click the <strong>"ADD"</strong> button at the top left to open the Add Other Income Item modal.
            </li>
            <li>
              Select an <strong>Other Income Group</strong> from the dropdown menu and enter the <strong>Other Income Item</strong> name and <strong>Remark</strong> in the provided fields. All fields are required.
            </li>
            <li>Befor clicking on save button ensure all required fields are filled out correctly</li>
            <li>
              Then click the <strong>"SAVE"</strong> button to add the item.
            </li>
            <li>
              If any required field is missing, an alert will dispaly to you to fill all required fields.
            </li>
            <li>
             If you want to reset the form,then  click the <strong>"RESET"</strong> button to clear all form fields if needed.
            </li>
          </ul>
          <Typography variant="body2" sx={{ mt: 2, color: theme.palette.text.primary }}>
            ⚠️ Note: All fields (Other Income Group, Other Income Item, and Remark) are required to save an item.
          </Typography>

          {/* Section 3: Edit an Other Income Item */}
          <Typography
            variant="body1"
            sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mt: 3, mb: 1 }}
          >
            ➤ Follow these steps to update an other income item:
          </Typography>
          <ul
            style={{
              marginLeft: '20px',
              lineHeight: '1.8',
              cursor: 'default',
            }}
          >
            <li>
              In the other income items table, select the item whose record you want to update.
            </li>
            <li>
              Click the <strong>Edit</strong> icon (pencil) in the Action column for the desired item.
            </li>
            <li>
              The Edit Other Income Item modal will open, with the form pre-populated with the item’s details.
            </li>
            <li>
              You can update the necessary fields a/c to your requirements.
            </li>
            <li>before clicking on update button enusre the all required fields are fill correctly</li>
            <li>
             Then  click the <strong>"UPDATE"</strong> button to save changes.
            </li>
            <li>
              If any required field is missing, an alert will prompt you to fill all fields.
            </li>
            <li>
              Click the <strong>"CANCEL"</strong> button to discard changes and close the modal.
            </li>
          </ul>
          <Typography variant="body2" sx={{ mt: 2, color: theme.palette.text.primary }}>
            ⚠️ Note: All fields (Other Income Group, Other Income Item, and Remark) are required to update an item.
          </Typography>

          {/* Section 4: Delete an Other Income Item */}
          <Typography
            variant="body1"
            sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mt: 3, mb: 1 }}
          >
            ➤ Follow these steps to delete an other income item:
          </Typography>
          <ul
            style={{
              marginLeft: '20px',
              lineHeight: '1.8',
              cursor: 'default',
            }}
          >
            <li>
              In the other income items table, select the item whose record you want to delete.
            </li>
            <li>
              Click the <strong>Delete</strong> icon button in the Action column for the desired item.
            </li>
            <li>
              A confirmation modal will appear, asking you to confirm the deletion.
            </li>
            <li>
              Click <strong>"Yes, Delete"</strong> to remove the item, or <strong>"Cancel"</strong> to close the modal without deleting.
            </li>
          </ul>
          <Typography variant="body2" sx={{ mt: 2, color: theme.palette.text.primary }}>
            ⚠️ Note: Deleting an other income item is permanent and cannot be undone.
          </Typography>

          {/* Section 5: Navigate the Other Income Items List */}
          <Typography
            variant="body1"
            sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mt: 3, mb: 1 }}
          >
            ➤ Follow these steps to navigate the other income items list:
          </Typography>
          <ul
            style={{
              marginLeft: '20px',
              lineHeight: '1.8',
              cursor: 'default',
            }}
          >
            <li>
              Use the pagination controls at the bottom to navigate through pages of other income items.
            </li>
            <li>
              Click the left (<strong>&lt;</strong>) or right (<strong>&gt;</strong>) arrows to move between pages.
            </li>
            <li>
              Select a specific page number by clicking on it.
            </li>
            <li>
              Adjust the number of rows per page using the dropdown menu (e.g., 5, 10, 20, 30 rows).
            </li>
          </ul>
          <Typography variant="body2" sx={{ mt: 2, color: theme.palette.text.primary }}>
            ⚠️ Note: The table displays only the selected number of rows per page. If no items match the search term, "No Data Found" will be displayed.
          </Typography>

          {/* Bottom Close Button */}
          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
            {/* <Button
              variant="contained"
              onClick={() => setShowUserGuideModal(false)}
              sx={{
                backgroundColor: theme.palette.primary.main,
                '&:hover': { backgroundColor: theme.palette.primary.dark },
                fontWeight: 'bold',
                padding: '8px 24px',
                borderRadius: '8px',
              }}
            >
              Close
            </Button> */}
          </Box>
        </CustomTableScrollbar>
      </Box>
    </Modal>
    <Snackbar
  open={openSnackbar}
  autoHideDuration={4000}
  onClose={() => setOpenSnackbar(false)}
  anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
>
  <Alert onClose={() => setOpenSnackbar(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
    {snackbarMessage}
  </Alert>
</Snackbar>
    </Container>
  );
};

export default OtherIncomeItem;